import action from "../action";

export const SET_CURRENT_TEAM = "SET_CURRENT_TEAM";
export const SET_TIMER = "SET_TIMER";
export const BUZZ_INFO = "BUZZ_INFO";

export const setCurrentTeam = (data) =>
  action({
    type: "SET_CURRENT_TEAM",
    data,
  });

export const setTimerOfGame = (data) =>
  action({
    type: "SET_TIMER",
    data,
  });

export const setBuzzInfo = (data) =>
  action({
    type: "BUZZ_INFO",
    data,
  });
